import { Route } from "react-router";
import { ProtectedRoute } from "./components";
import {
  Documents,
  EnergyConsumption,
  Carbon,
  Procurement,
  Budget,
} from "@/pages";
import React from "react";
import {
  permissionsDocumentsReadonly,
  permissionsEnergy,
  permissionsClimate,
  permissionsCost,
  permissionsBudget,
} from "@/utils";
import { corporateGroupRoutes } from "./corporateGroupRoutes";
import { energyContractRoutes } from "./energyContractRoutes";
import { partnerAdminRoutes } from "./partnerAdminRoutes";
import { statementRoutes } from "./statementRoutes";
import { supportRoutes } from "./supportRoutes";
import { systemRoutes } from "./systemRoutes";
import { userAccountRoutes } from "./userAccountRoutes";
import { qadeerRoutes } from "./qadeerRoutes";
import { developerRoutes } from "./developerRoutes";
import { documentRoutes } from "./documentRoutes";

export const rootRoutes: React.ReactElement[] = [
  <Route
    key="energy"
    path="energy"
    element={
      <ProtectedRoute
        element={<EnergyConsumption />}
        codes={permissionsEnergy}
      />
    }
  />,
  <Route
    key="climate"
    path="climate"
    element={<ProtectedRoute element={<Carbon />} codes={permissionsClimate} />}
  />,
  <Route
    key="procurement"
    path="procurement"
    element={
      <ProtectedRoute element={<Procurement />} codes={permissionsCost} />
    }
  />,
  <Route
    key="budget"
    path="budget"
    element={<ProtectedRoute element={<Budget />} codes={permissionsBudget} />}
  />,
  <Route
    key="documents"
    path="documents"
    element={
      <ProtectedRoute
        element={<Documents />}
        codes={permissionsDocumentsReadonly}
      />
    }
  />,
  <Route path="/statement">{statementRoutes}</Route>,
  <Route path="/energy-contract">{energyContractRoutes}</Route>,
  <Route path="/user-account">{userAccountRoutes}</Route>,
  <Route path="/partner-admin">{partnerAdminRoutes}</Route>,
  <Route path="/corporate-group">{corporateGroupRoutes}</Route>,
  <Route path="/system-admin">{systemRoutes}</Route>,
  <Route path="/developer">{developerRoutes}</Route>,
  <Route path="/support">{supportRoutes}</Route>,
  <Route path="/documents">{documentRoutes}</Route>,
  <Route path="/qadeer">{qadeerRoutes}</Route>,
];
